"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _grid = require("./grid.tokens");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Row = require("./Row.styled");
var _Cell = require("./Cell.styled");
var Grid = exports.Grid = _styledComponents.default.div.withConfig({
  displayName: "Gridstyled__Grid",
  componentId: "sc-1u4dc4l-0"
})(["display:grid;gap:", ";padding:", ";background-color:", ";border-radius:", ";> ", ":first-child{> ", ":last-child{border-top-right-radius:inherit;}> ", ":first-child{border-top-left-radius:inherit;}}> ", ":last-child{> ", ":first-child{border-bottom-left-radius:inherit;}> ", ":last-child{border-bottom-right-radius:inherit;}}"], function (_ref) {
  var borderWidth = _ref.borderWidth;
  return _grid.gridTokens.border.width[borderWidth || _grid.Width.default];
}, function (_ref2) {
  var borderWidth = _ref2.borderWidth;
  return _grid.gridTokens.border.width[borderWidth || _grid.Width.default];
}, function (_ref3) {
  var borderColor = _ref3.borderColor;
  return _grid.gridTokens.border.color[borderColor || _grid.BorderColor.default];
}, function (_ref4) {
  var borderRadius = _ref4.borderRadius;
  return _grid.gridTokens.border.radius[borderRadius || _grid.Radius.default];
}, _Row.RowWrapper, _Cell.Cell, _Cell.Cell, _Row.RowWrapper, _Cell.Cell, _Cell.Cell);